import React, { FC, memo, useEffect } from "react"
import { FetchedCourse } from "./BookingPricePreview"
import { DiscountUnit, GenerateScheduledPaymentsByCourseMutation, NewBookingInput, PaymentInterval, useGetAttendeeMemberStatusQuery } from "../../../../generated/graphql"
import { useCurrency } from "../../../../helpers/currencyHelper"
import { renderAmount } from "../../../../helpers/renderAmount"
import css from "./MemberDiscount.module.css"
import LoadingContent from "../../../../views/LoadingContent/LoadingContent"

type MemberDiscountProps = {
    course: FetchedCourse
    bookingData: NewBookingInput
    attendeeId: string
    setDiscountInEuro: (value: number | null) => void
    setDiscountInPercentage: (value: number | null) => void
    preview?: GenerateScheduledPaymentsByCourseMutation["generateScheduledPaymentsByCourse"]
}

const MemberDiscount: FC<MemberDiscountProps> = ({ course, bookingData, attendeeId, setDiscountInEuro, setDiscountInPercentage, preview }) => {
    const currency = useCurrency()
    const booking = bookingData
    const allreadyAccountedDiscount = booking.memberDiscount
    const { lessonCount, paymentInterval } = course
    const { grossPrice, discountUnit } = course.coursePrice[0]
    const totalPrice = paymentInterval === PaymentInterval.PerLesson ? grossPrice * (lessonCount ?? 1) : grossPrice
    const { data, loading } = useGetAttendeeMemberStatusQuery({
        variables: {
            id: attendeeId,
        },
        fetchPolicy: "network-only",
    })
    const attendeeIsMember = data?.attendee?.member ?? false
    const getDiscoutnInPercentage = (discountInEuro: number) => {
        return (discountInEuro / totalPrice) * 100
    }
    const discountInEuro = preview?.memberDiscount ?? 0
    const discountInPercentage = getDiscoutnInPercentage(discountInEuro)

    useEffect(() => {
        if (attendeeIsMember && !allreadyAccountedDiscount) {
            setDiscountInEuro(discountInEuro)
            setDiscountInPercentage(discountInPercentage)
        }
    }, [discountInEuro, discountInPercentage, attendeeIsMember, allreadyAccountedDiscount, setDiscountInEuro, setDiscountInPercentage, loading])

    if (loading) {
        return <LoadingContent />
    }

    if (!attendeeIsMember) {
        // return <h3 style={{ background: "red", color: "white" }}>{"Teilnehmer ist kein Mitglied!"}</h3>
        return null
    }

    const discountAsMoney = renderAmount({
        amount: discountInEuro,
        currency: currency.short as any,
    })

    const discountAsPercentage = `${discountInPercentage.toFixed(0)} %`

    const discountText = discountUnit === DiscountUnit.Percentage ? discountAsPercentage : discountAsMoney

    return (
        <div className={css.root} data-testid='member-discount' id='member-discount'>
            <div className={css.mainContent}>
                <div>{"Verrechneter Mitgliederrabatt"}</div>
                <div></div>
                {discountAsMoney}
            </div>
            <div className={css.description}>{`Als Mitglied erhalten Sie einen Rabatt von ${discountText}`}</div>
        </div>
    )
}

export default memo(MemberDiscount)
